import { IconLoader } from '@ui/src';
import LanguagesForm from '../../../components/settings/details-form/languages';
import useLanguages from './hooks/use-languanges';
import EditSidepanel from '../../../components/settings/details-form/edit-sidepanel';

import cn from '../styles.module.css';

const PSPLanguages = () => {
  const {
    isLoading,
    errorList,
    control,
    onSubmit,
    globalError,
    editIsLoading,
    isDirty,
    editPanelIsOpen,
    setEditPanelIsOpen,
    editPanelType,
    setEditPanelType,
    editKey,
    setEditKey,
    handleClose,
    setValue,
    setNotEditKey,
    onSearchLanguages,
    filteredLanguagesList,
    dirtyPopupVisible,
    setDirtyPopupVisible,
    allAvailableLanguages,
    fields,
    errors,
    searchText,
  } = useLanguages();

  let content;

  if (isLoading) {
    content = (
      <div className={cn.settingsLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <>
        {!errorList && (
          <div className={cn.languagesWrapper}>
            <div className={cn.languagesWrapperTop}>
              <div className={cn.pspSettingsLanguageTitle}>Transactions</div>
              <LanguagesForm
                control={control}
                availableNameKey="transactionsAvailableLanguages"
                notAvailableNameKey="transactionsNotAvailableLanguages"
                setEditPanelType={setEditPanelType}
                setEditPanelIsOpen={setEditPanelIsOpen}
                setEditKey={setEditKey}
                type="transactions"
                setNotEditKey={setNotEditKey}
              />
              <div className={cn.pspSettingsLanguageTitle}>Applications</div>
              <LanguagesForm
                control={control}
                availableNameKey="applicationsAvailableLanguages"
                notAvailableNameKey="applicationsNotAvailableLanguages"
                setEditPanelType={setEditPanelType}
                setEditPanelIsOpen={setEditPanelIsOpen}
                setEditKey={setEditKey}
                type="applications"
                setNotEditKey={setNotEditKey}
              />
              <div className={cn.pspSettingsLanguageTitle}>Documents</div>
              <LanguagesForm
                control={control}
                availableNameKey="documentsAvailableLanguages"
                notAvailableNameKey="documentsNotAvailableLanguages"
                setEditPanelType={setEditPanelType}
                setEditPanelIsOpen={setEditPanelIsOpen}
                setEditKey={setEditKey}
                type="documents"
                setNotEditKey={setNotEditKey}
              />
            </div>
          </div>
        )}
        {errorList && (
          <div className={cn.loadingError}>
            <div className={cn.loadingErrorTitle}>Unable to load data</div>
            <div className={cn.loadingErrorText}>{errorList}</div>
          </div>
        )}
        <EditSidepanel
          editPanelIsOpen={editPanelIsOpen}
          setDirtyPopupVisible={setDirtyPopupVisible}
          isDirty={isDirty}
          handleClose={handleClose}
          globalError={
            (editKey && errors && errors[editKey]?.message) || globalError
          }
          editPanelType={editPanelType}
          editKey={editKey}
          editIsLoading={editIsLoading}
          onSubmit={onSubmit}
          searchText={searchText}
          onSearchLanguages={onSearchLanguages}
          setValue={setValue}
          allAvailableLanguages={allAvailableLanguages}
          fields={fields}
          control={control}
          filteredLanguagesList={filteredLanguagesList}
          dirtyPopupVisible={dirtyPopupVisible}
        />
        <div id="dirty-popup" />
      </>
    );
  }

  return content;
};

export default PSPLanguages;
